import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import PropertyHeroSection from '../../components/PropertyHeroSection/PropertyHeroSection';
import PremiumCarousel from '../../components/PremiumCarousel/PremiumCarousel';
import Accommodations from '../../components/Accommodations/Accommodations';
import AtacamaVideoSection from '../../components/AtacamaVideoSection/AtacamaVideoSection';
import AtacamaExperiencesSection from '../../components/AtacamaExperiencesSection/AtacamaExperiencesSection';
import AtacamaOffersSection from '../../components/AtacamaOffersSection/AtacamaOffersSection';
import AtacamaMapSection from '../../components/AtacamaMapSection/AtacamaMapSection';
import AtacamaBlogSection from '../../components/AtacamaBlogSection/AtacamaBlogSection';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import Footer from '../../components/Footer/Footer';
import { images } from '../../components/shared/assets';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import '../../styles/property-pages.css';
import './MendozaPage.css';

const MendozaPageHardcoded: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const { t } = useTranslation();

  // Initialize all interactive features
  useEffect(() => {
    const cleanup = initializeAllFeatures();
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
    return cleanup;
  }, []);

  return (
    <div className="property-page property-page--mendoza">
      {/* Navigation - Transparent variant for hero section */}
      <UnifiedNavigation variant="transparent" destination="mendoza" />
      
      {/* Hero Section */}
      <div className="hero-section-wrapper">
        <PropertyHeroSection 
          propertySlug="mendoza"
          customContent={{
            title: t('properties/mendoza:hero.title'),
            copy: '' // Explicitly disable description text
          }}
        />
      </div>

      {/* Content Sections with Scroll Reveals */}
      <div className="content-wrapper">
        
        {/* Premium Carousel - The horizontal carousel we fixed */}
        <div data-scroll-section="carousel" className="scroll-reveal-section">
          <PremiumCarousel property="mendoza" />
        </div>

        {/* Accommodations Section */}
        <div data-scroll-section="accommodations" className="scroll-reveal-section">
          <Accommodations property="mendoza" />
        </div>

        {/* Full Viewport Video Section */}
        <AtacamaVideoSection />

        {/* Experience Your Own Path Private Excursions Section */}
        <div data-scroll-section="experiences" className="scroll-reveal-section">
          <AtacamaExperiencesSection property="mendoza" />
        </div>

        {/* Offers Section */}
        <div data-scroll-section="offers" className="scroll-reveal-section">
          <AtacamaOffersSection property="mendoza" />
        </div>

        {/* Map Section */}
        <div data-scroll-section="map" className="scroll-reveal-section">
          <AtacamaMapSection property="mendoza" />
        </div>

        {/* Blog Section */}
        <div data-scroll-section="blog" className="scroll-reveal-section">
          <AtacamaBlogSection />
        </div>

        {/* Instagram Section */}
        <InstagramSection 
          title={t('properties/mendoza:instagram.title')}
          posts={[
            { src: images.instagram1, alt: "Instagram 1" },
            { src: images.instagram2, alt: "Instagram 2" },
            { src: images.instagram3, alt: "Instagram 3" },
            { src: images.instagram4, alt: "Instagram 4" }
          ]}
        />

        {/* Footer */}
        <Footer variant="mendoza" />
      </div>
    </div>
  );
};

export default MendozaPageHardcoded;